import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';

import { 
	ddnyTitle,
	ddnyThumbnailSrc, 
} from '../../../../utils/ddny';

import styles from './_styles/GalleryItem.module.scss';

const allActionCreators = Object.assign({});

export class GalleryItem extends Component {

	render() {
		return <div className={`${styles.GalleryItem} ${this.props.product?.is_enabled === false ? styles.disabled : ''}`}>
			<Link to={`/ddny/jewelry/${this.props.product?.id}`} className={styles.itemLink}>
				<div className={styles.itemWrapper}>
					<div className={styles.mediaWrapper}>
						<div className={styles.mediaElement}>
							<div className={styles.imgFrame}>
								<img src={ddnyThumbnailSrc(this.props.product)} />
							</div>
						</div>
					</div>
					<div className={styles.titleWrapper}>
						<div className={styles.title}>{ddnyTitle(this.props.product)}</div>
					</div>
					<div className={styles.actionWrapper}>
						<button type='button' className={`${styles.action} actionButton`}>View</button>
					</div>
					{this.props.product?.is_enabled === false && (
						<div className={styles.disabledScreen} />
					)}
				</div>
			</Link>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(GalleryItem);